import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { saveTokensToStorage, clearTokensFromStorage } from './store/tokensPersistence';

// Persist tokens to localStorage so refresh / BO restart doesn't log the user out
store.subscribe(() => {
  const state = store.getState();
  const tokens = state.tokens;
  if (tokens?.accessToken || tokens?.refreshToken) {
    saveTokensToStorage(tokens);
  } else {
    clearTokensFromStorage();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
